import React from 'react';
import { getPropTypes } from './Language';
import LanguageSelection from './LanguageSelection';

import './_styles.css';

function LanguageDesktop(props) {
  return (
    <div>
      <LanguageSelection className="Language__Selection" {...props} />
    </div>
  );
}

LanguageDesktop.propTypes = getPropTypes;

export default LanguageDesktop;
